import "./BakeryGrid.css";

import BakeryCard from "../BakeryCard/BakeryCard";

function BakeryGrid({
  products = [],
  onView,
  onEdit,
  onDelete,
  onToggle,
}) {
  if (products.length === 0) {
    return (
      <div className="bakery-empty">
        <h3>No Bakery Products Found</h3>
        <p>Add your first bakery product.</p>
      </div>
    );
  }

  return (
    <div className="bakery-grid">
      {products.map((product) => (
        <BakeryCard
          key={product._id}
          product={product}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
}

export default BakeryGrid;